module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dialogs"
  }, [_c('div', {
    staticClass: "dialog",
    class: {
      'dialog-active': _vm.show
    }
  }, [_c('div', {
    staticClass: "dialog-content"
  }, [_c('div', {
    staticClass: "close rotate"
  }, [_c('span', {
    staticClass: "fa fa-times",
    on: {
      "click": _vm.close
    }
  })]), _vm._v(" "), _vm._t("header"), _vm._v(" "), _vm._t("body"), _vm._v(" "), _vm._t("footer")], 2)]), _vm._v(" "), _c('div', {
    staticClass: "dialog-overlay"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.3.0@vue-loader/lib/template-compiler.js?id=data-v-1ec72c32!./~/.10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog.vue
// module id = 30
// module chunks = 1